import React from 'react'
import { graphql, useStaticQuery } from "gatsby"

import Layout from '../components/layout'
import Sidebar from '../components/sidebar'

const DocsTemplate = () => {
  const data = useStaticQuery(graphql`
    query {
      allSidebarItem {
        nodes {
          id
          title
          link
          items {
            title
            link
          }
        }
      }
    }
  `)
  const docs = data.allSidebarItem.nodes
  
  return (
    <Layout>
      <Sidebar docs={docs}/>
    </Layout>
  )
}

export default DocsTemplate